// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   FormControl, InputLabel, Select, MenuItem,
//   Paper, Chip, Fade, Stack, CircularProgress, Grid
// } from '@mui/material';
// import {
//   CheckCircle as CheckIcon,
//   Schedule as PendingIcon,
//   Edit as EditIcon,
//   Email as EmailIcon,
//   Phone as PhoneIcon,
//   Person as PersonIcon,
//   Assignment as AssignmentIcon,
//   Note as NoteIcon,
//   Gavel as GavelIcon
// } from '@mui/icons-material';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../../config';
// import api from '../../../api/axiosInterceptor';

// export const SplocaOfficerGrievanceComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [actionDialogOpen, setActionDialogOpen] = useState(false);
//   const [selectedGrievance, setSelectedGrievance] = useState(null);
//   const [actionFormData, setActionFormData] = useState({
//     sploca_remarks: '',
//     resolved_by_sploca: 'True'
//   });

//   // SPLoCA columns - shows AC + JS details
//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'akn_no', field: 'akn_no', headerName: 'Ack No.', width: 190 },
//     {
//       id: 'user_name',
//       field: 'user_name',
//       headerName: 'Submitted By',
//       width: 120,
//       renderCell: (params) => (
//         <Stack direction="row" spacing={0.5} alignItems="center">
//           {/* <PersonIcon fontSize="small" color="action" /> */}
//           <Typography variant="body2">{params.value}</Typography>
//         </Stack>
//       ),
//     },
//     {
//       id: 'ac_officer',
//       field: 'ac_modified_by',
//       headerName: 'Reviewed By (AC)',
//       width: 130,
//       renderCell: (params) => {
//         const acUser = params.value;
//         return acUser ? (
//           <Chip label={acUser.name } size="small" color="success" variant="outlined" />
//         ) : '—';
//       },
//     },
//     {
//       id: 'js_officer',
//       field: 'js_modified_by',
//       headerName: 'Reviewed By (JS)',
//       width: 130,
//       renderCell: (params) => {
//         const jsUser = params.value;
//         return jsUser ? (
//           <Chip label={jsUser.name} size="small" color="warning" variant="outlined" />
//         ) : '—';
//       },
//     },
//     {
//       id: 'complaint_type',
//       field: 'complaint_type',
//       headerName: 'Type',
//       width: 110,
//     },
//     {
//       id: 'complaint_regarding',
//       field: 'complaint_regarding',
//       headerName: 'Regarding',
//       width: 220,
//     },
//     {
//       id: 'status',
//       field: 'status',
//       headerName: 'Status',
//       width: 120,
//       renderCell: () => (
//         <Chip
//           icon={<PendingIcon />}
//           label="Pending SPLOCA"
//           color="warning"
//           size="small"
//           variant="outlined"
//         />
//       ),
//     },
//     {
//       id: 'action',
//       field: 'action',
//       headerName: 'Final Action',
//       width: 140,
//       renderCell: (params) => (
//         <Stack direction="row" spacing={1}>
//           <Chip
//             icon={<GavelIcon />}
//             label="AC+JS Done"
//             color="success"
//             size="small"
//             variant="outlined"
//           />
//           <IconButton
//             color="primary"
//             size="small"
//             title="Final SPLOCA Decision"
//             onClick={() => handleActionClick(params.row)}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//         </Stack>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchSplocaGrievances();
//   }, []);

//   const fetchSplocaGrievances = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(
//         `${API_BASE_URL}/grievance/officer-sploca-grievances/`
//       );

//       const apiData = res.data.map((item, index) => {
//         const g = item.grievance || {};
//         const createdBy = g.created_by || {};
//         const acModifiedBy = g.ac_modified_by || {};
//         const jsModifiedBy = g.js_modified_by || {};

//         return {
//           id: item.id,
//           slNo: index + 1,
//           grievance_raw: item,
//           grievance_id: g.id,
//           akn_no: g.akn_no,
//           Address: g.Address,
//           Description: g.Description,
//           complaint_type: g.complaint_type,
//           complaint_regarding: g.complaint_regarding,
//           status: g.status,
//           doc: g.doc,
          
//           // User details
//           user_name: createdBy.name || '',
//           user_email: createdBy.email || '',
//           user_phone: createdBy.phone_number || '',
          
//           // Previous officer details
//           ac_modified_by: acModifiedBy,
//           js_modified_by: jsModifiedBy,
          
//           // Remarks from previous levels
//           ac_remarks: item.ac_remarks || null,
//           js_remarks: item.js_remarks || null,
          
//           // Status flags
//           is_resolved_by_ac: item.is_resolved_by_ac,
//           is_resolved_by_js: item.is_resolved_by_js,
//           is_resolved_by_sploca: item.is_resolved_by_sploca,
//         };
//       });

//       setRows(apiData);
//     } catch (err) {
//       console.error(err);
//       setSnackbarMessage('Failed to load SPLOCA grievances.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleActionClick = (row) => {
//     setSelectedGrievance(row);
//     setActionFormData({
//       sploca_remarks: '',
//       resolved_by_sploca: 'True'
//     });
//     setActionDialogOpen(true);
//   };

//   const handleActionFormChange = (e) => {
//     const { name, value } = e.target;
//     setActionFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSplocaActionSubmit = async () => {
//     if (!selectedGrievance) return;

//     setSubmitLoading(true);
//     try {
//       await api.patch(
//         `${API_BASE_URL}/grievance/officer-sploca-grievances/${selectedGrievance.id}/`,
//         actionFormData
//       );

//       setSnackbarMessage('Final decision submitted successfully!');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       setActionDialogOpen(false);
//       fetchSplocaGrievances();
//     } catch (err) {
//       console.error(err);
//       setSnackbarMessage('Failed to submit final decision.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         minHeight="60vh"
//         display="flex"
//         alignItems="center"
//         justifyContent="center"
//         sx={{ backgroundColor: '#f5f5f5' }}
//       >
//         <CircularProgress size={40} thickness={4} />
//       </Box>
//     );
//   }

//   return (
//     <Fade in timeout={500}>
//       <Box
//         sx={{
//           width: '100%',
//           mt: 3,
//           mb: 3,
//           borderRadius: 3,
//           boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
//           background: 'linear-gradient(145deg,#ffffff 0%,#f8fafc 100%)',
//           border: '1px solid rgba(255,255,255,0.2)',
//         }}
//       >
//         {/* SPLoCA Header */}
//         <Paper
//           elevation={0}
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
//             color: 'white',
//             p: 3,
//             borderRadius: '16px 16px 0 0',
//           }}
//         >
//           <Stack direction="row" spacing={2} alignItems="center">
//             <Box
//               sx={{
//                 width: 50,
//                 height: 50,
//                 borderRadius: '12px',
//                 background: 'rgba(255,255,255,0.2)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               <GavelIcon sx={{ color: 'white' }} />
//             </Box>
//             <Box sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.4)' }}>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   fontWeight: 800,
//                   fontSize: '1.75rem',
//                   color: 'white',
//                   lineHeight: 1.2,
//                 }}
//               >
//                 Grievance Management
//               </Typography>
//               <Typography variant="body2" sx={{ opacity: 0.95, fontWeight: 500 }}>
//                 Final authority for grievance resolution
//               </Typography>
//             </Box>
//           </Stack>
//           <Typography variant="h6" sx={{ fontWeight: 600 }}>
//             Final Review: {rows.length}
//           </Typography>
//         </Paper>

//         {/* Table */}
//         <Box p={3}>
//           <TableComponent
//             columns={columns}
//             rows={rows}
//             manageColumnStatus
//             enableSort="true"
//             sx={{
//               borderRadius: 2,
//               '& .MuiDataGrid-columnHeaders': {
//                 background: 'linear-gradient(90deg,#9c27b0 0%,#7b1fa2 100%)',
//                 color: '#fff',
//                 fontWeight: 700,
//                 fontSize: '0.875rem',
//               },
//               '& .MuiDataGrid-row:hover': {
//                 backgroundColor: 'rgba(156,39,176,0.04)',
//               },
//             }}
//           />
//         </Box>

//         {/* SPLoCA Final Decision Dialog */}
//         <Dialog
//           open={actionDialogOpen}
//           onClose={() => setActionDialogOpen(false)}
//           maxWidth="lg"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{
//               background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
//               color: 'white',
//               fontWeight: 700,
//               py: 2.5,
//               px: 3,
//             }}
//           >
//             Final Decision – {selectedGrievance?.akn_no}
//           </DialogTitle>
//           <DialogContent sx={{ p: 3 }}>
//             {/* Complete Workflow Summary */}
//             <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
//               <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: '#1976d2' }}>
//                 Complete Workflow History
//               </Typography>
              
//               <Grid container spacing={3}>
//                 {/* User Info */}
//                 <Grid item xs={12} md={4}>
//                   <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
//                     <Typography variant="subtitle1" fontWeight={600} mb={1}>
//                       Submitted By
//                     </Typography>
//                     <Typography variant="body1" fontWeight={500}>
//                       {selectedGrievance?.user_name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {selectedGrievance?.user_email}
//                     </Typography>
//                   </Paper>
//                 </Grid>

//                 {/* AC Details */}
//                 <Grid item xs={12} md={4}>
//                   <Paper variant="outlined" sx={{ p: 2, height: '100%', bgcolor: '#e8f5e8' }}>
//                     <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                       <PersonIcon color="success" />
//                       <Typography variant="subtitle1" fontWeight={600}>
//                         Reviewed By (AC)
//                       </Typography>
//                     </Stack>
//                     <Typography variant="body1" color="success.main">
//                       {selectedGrievance?.ac_modified_by?.name || 'AC Officer'}
//                     </Typography>
//                     {selectedGrievance?.ac_remarks && (
//                       <Typography variant="body2" color="success.dark" sx={{ mt: 1 }}>
//                         "{selectedGrievance.ac_remarks}"
//                       </Typography>
//                     )}
//                   </Paper>
//                 </Grid>

//                 {/* JS Details */}
//                 <Grid item xs={12} md={4}>
//                   <Paper variant="outlined" sx={{ p: 2, height: '100%', bgcolor: '#fff3e0' }}>
//                     <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                       <PersonIcon color="warning" />
//                       <Typography variant="subtitle1" fontWeight={600}>
//                         Reviewed By (JS)
//                       </Typography>
//                     </Stack>
//                     <Typography variant="body1" color="warning.main">
//                       {selectedGrievance?.js_modified_by?.name || 'JS Officer'}
//                     </Typography>
//                     {selectedGrievance?.js_remarks && (
//                       <Typography variant="body2" color="warning.dark" sx={{ mt: 1 }}>
//                         "{selectedGrievance.js_remarks}"
//                       </Typography>
//                     )}
//                   </Paper>
//                 </Grid>

//                 {/* Grievance Details */}
//                 <Grid item xs={12}>
//                   <Paper variant="outlined" sx={{ p: 2 }}>
//                     <Typography variant="subtitle1" fontWeight={600} mb={2}>
//                       Grievance Details
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={3}>
//                         <Typography variant="subtitle2" color="text.secondary">Ack No:</Typography>
//                         <Typography variant="body1">{selectedGrievance?.akn_no}</Typography>
//                       </Grid>
//                       <Grid item xs={12} md={3}>
//                         <Typography variant="subtitle2" color="text.secondary">Type:</Typography>
//                         <Typography variant="body1">{selectedGrievance?.complaint_type}</Typography>
//                       </Grid>
//                       <Grid item xs={12} md={6}>
//                         <Typography variant="subtitle2" color="text.secondary">Status:</Typography>
//                         <Typography variant="body1">{selectedGrievance?.status}</Typography>
//                       </Grid>
//                     </Grid>
//                   </Paper>
//                 </Grid>
//               </Grid>
//             </Paper>

//             {/* SPLoCA Final Decision */}
//             <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
//               <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
//                 Final Decision <span style={{ color: 'red' }}>*</span>
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <FormControl fullWidth>
//                     <InputLabel>Final Status</InputLabel>
//                     <Select
//                       name="resolved_by_sploca"
//                       label="Final Status"
//                       value={actionFormData.resolved_by_sploca}
//                       onChange={handleActionFormChange}
//                     >
//                       <MenuItem value="True">
//                         ✅ Approved & Resolved
//                       </MenuItem>
//                       <MenuItem value="False">
//                         ❌ Rejected
//                       </MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     name="sploca_remarks"
//                     label="SPLOCA Final Remarks *"
//                     fullWidth
//                     multiline
//                     rows={5}
//                     value={actionFormData.sploca_remarks}
//                     onChange={handleActionFormChange}
//                     placeholder="Enter final decision and remarks..."
//                     required
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </DialogContent>
//           <DialogActions sx={{ p: 3, pt: 0 }}>
//             <Button
//               onClick={() => setActionDialogOpen(false)}
//               variant="outlined"
//               disabled={submitLoading}
//               sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSplocaActionSubmit}
//               variant="contained"
//               disabled={submitLoading || !actionFormData.sploca_remarks.trim()}
//               sx={{
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 4,
//                 background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
//                 '&:hover': {
//                   background: 'linear-gradient(135deg,#8e24aa 0%,#6a1b9a 100%)',
//                 }
//               }}
//             >
//               {submitLoading ? (
//                 <>
//                   <CircularProgress size={20} sx={{ mr: 1 }} />
//                   Finalizing...
//                 </>
//               ) : (
//                 'Submit'
//               )}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <SnackBarComponent
//           open={snackbarOpen}
//           onClose={handleSnackbarClose}
//           message={snackbarMessage}
//           severity={snackbarSeverity}
//         />
//       </Box>
//     </Fade>
//   );
// };



import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  FormControl, InputLabel, Select, MenuItem,
  Paper, Chip, Fade, Stack, CircularProgress, Grid
} from '@mui/material';
import {
  Schedule as PendingIcon,
  Edit as EditIcon,
  Person as PersonIcon,
  Gavel as GavelIcon
} from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';

export const SplocaOfficerGrievanceComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [actionFormData, setActionFormData] = useState({
    sploca_remarks: '',
    resolved_by_sploca: 'True'
  });

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'akn_no', field: 'akn_no', headerName: 'Ack No.', width: 160 },
    {
      id: 'user_name',
      field: 'user_name',
      headerName: 'Submitted By',
      width: 140,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Typography variant="body2">{params.value}</Typography>
        </Stack>
      ),
    },
    {
      id: 'ac_officer',
      field: 'ac_modified_by',
      headerName: 'Reviewed By (AC)',
      width: 140,
      renderCell: (params) => {
        const acUser = params.value;
        return acUser ? (
          <Chip label={acUser.name} size="small" color="success" variant="outlined" />
        ) : '—';
      },
    },
    {
      id: 'js_officer',
      field: 'js_modified_by',
      headerName: 'Reviewed By (JS)',
      width: 140,
      renderCell: (params) => {
        const jsUser = params.value;
        return jsUser ? (
          <Chip label={jsUser.name} size="small" color="warning" variant="outlined" />
        ) : '—';
      },
    },
    {
      id: 'complaint_type',
      field: 'complaint_type',
      headerName: 'Type',
      width: 110,
    },
    {
      id: 'complaint_regarding',
      field: 'complaint_regarding',
      headerName: 'Regarding',
      width: 200,
    },
    {
      id: 'status',
      field: 'status',
      headerName: 'Status',
      width: 130,
      renderCell: () => (
        <Chip
          icon={<PendingIcon />}
          label="Pending SPLOCA"
          color="warning"
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      id: 'action',
      field: 'action',
      headerName: 'Final Action',
      width: 130,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Chip
            icon={<GavelIcon />}
            label="AC+JS Done"
            color="success"
            size="small"
            variant="outlined"
          />
          <IconButton
            color="primary"
            size="small"
            title="Final SPLOCA Decision"
            onClick={() => handleActionClick(params.row)}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Stack>
      ),
    },
  ];

  useEffect(() => {
    fetchSplocaGrievances();
  }, []);

  const fetchSplocaGrievances = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/grievance/officer-sploca-grievances/`
      );

      const apiData = res.data.map((item, index) => {
        const g = item.grievance || {};
        const createdBy = g.created_by || {};
        const acModifiedBy = g.ac_modified_by || {};
        const jsModifiedBy = g.js_modified_by || {};

        return {
          id: item.id,
          slNo: index + 1,
          grievance_raw: item,
          grievance_id: g.id,
          akn_no: g.akn_no,
          Address: g.Address,
          Description: g.Description,
          complaint_type: g.complaint_type,
          complaint_regarding: g.complaint_regarding,
          status: g.status,
          doc: g.doc,

          user_name: createdBy.name || '',
          user_email: createdBy.email || '',
          user_phone: createdBy.phone_number || '',

          ac_modified_by: acModifiedBy,
          js_modified_by: jsModifiedBy,

          ac_remarks: item.ac_remarks || null,
          js_remarks: item.js_remarks || null,

          is_resolved_by_ac: item.is_resolved_by_ac,
          is_resolved_by_js: item.is_resolved_by_js,
          is_resolved_by_sploca: item.is_resolved_by_sploca,
        };
      });

      setRows(apiData);
    } catch (err) {
      console.error(err);
      setSnackbarMessage('Failed to load SPLOCA grievances.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleActionClick = (row) => {
    setSelectedGrievance(row);
    setActionFormData({
      sploca_remarks: '',
      resolved_by_sploca: 'True'
    });
    setActionDialogOpen(true);
  };

  const handleActionFormChange = (e) => {
    const { name, value } = e.target;
    setActionFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSplocaActionSubmit = async () => {
    if (!selectedGrievance) return;

    setSubmitLoading(true);
    try {
      await api.patch(
        `/grievance/officer-sploca-grievances/${selectedGrievance.id}/`,
        actionFormData
      );

      setSnackbarMessage('Final decision submitted successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setActionDialogOpen(false);
      fetchSplocaGrievances();
    } catch (err) {
      console.error(err);
      setSnackbarMessage('Failed to submit final decision.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        minHeight="60vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ backgroundColor: '#f5f5f5' }}
      >
        <CircularProgress size={40} thickness={4} />
      </Box>
    );
  }

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          width: '100%',
          mt: 3,
          mb: 3,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          background: 'linear-gradient(145deg,#ffffff 0%,#f8fafc 100%)',
          border: '1px solid rgba(255,255,255,0.2)',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
            color: 'white',
            p: 3,
            borderRadius: '16px 16px 0 0',
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 50,
                height: 50,
                borderRadius: '12px',
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <GavelIcon sx={{ color: 'white' }} />
            </Box>
            <Box sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.4)' }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  fontSize: '1.75rem',
                  color: 'white',
                  lineHeight: 1.2,
                }}
              >
                Grievance Management
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.95, fontWeight: 500 }}>
                Final authority for grievance resolution
              </Typography>
            </Box>
          </Stack>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Final Review: {rows.length}
          </Typography>
        </Paper>

        <Box p={3}>
          <TableComponent
            columns={columns}
            rows={rows}
            manageColumnStatus
            enableSort="true"
            sx={{
              borderRadius: 2,
              '& .MuiDataGrid-columnHeaders': {
                background: 'linear-gradient(90deg,#9c27b0 0%,#7b1fa2 100%)',
                color: '#fff',
                fontWeight: 700,
                fontSize: '0.875rem',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: 'rgba(156,39,176,0.04)',
              },
            }}
          />
        </Box>

        {/* Dialog - FIXED Overflow */}
        <Dialog
          open={actionDialogOpen}
          onClose={() => setActionDialogOpen(false)}
          maxWidth="md"
          fullWidth
          scroll="paper"
          sx={{
            '& .MuiDialog-paper': {
              maxHeight: '90vh',
            },
          }}
        >
          <DialogTitle
            sx={{
              background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
              color: 'white',
              fontWeight: 700,
              py: 2,
              px: 3,
            }}
          >
            Final Decision – {selectedGrievance?.akn_no}
          </DialogTitle>

          <DialogContent sx={{ p: 3, pb: 2 }}>
            {/* 1. Grievance Details FIRST */}
            <Paper elevation={1} sx={{ p: 2.5, mb: 2.5, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                Grievance Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Ack No:
                  </Typography>
                  <Typography variant="body1" fontWeight={600}>
                    {selectedGrievance?.akn_no || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Type:
                  </Typography>
                  <Typography variant="body1">
                    {selectedGrievance?.complaint_type || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Status:
                  </Typography>
                  <Typography variant="body1">
                    {selectedGrievance?.status || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Description:
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.Description || 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>

            {/* 2. Complete Workflow History - FIXED CONTAINMENT */}
            <Paper 
              elevation={1} 
              sx={{ 
                p: 2.5, 
                mb: 2.5, 
                borderRadius: 2,
                overflow: 'hidden' // Prevents child overflow
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                Complete Workflow History
              </Typography>

              <Grid container spacing={1.5} sx={{ width: '100%' }}>
                {/* Submitted By */}
                <Grid item xs={12} sm={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      height: 120,
                      borderRadius: 1.5,
                      boxSizing: 'border-box', // Ensures padding included in width
                      width: '100%',
                      overflow: 'hidden'
                    }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                      <PersonIcon color="primary" fontSize="small" />
                      <Typography variant="subtitle2" fontWeight={600} noWrap>
                        Submitted By
                      </Typography>
                    </Stack>
                    <Typography variant="body2" fontWeight={600} noWrap sx={{ mb: 0.5 }}>
                      {selectedGrievance?.user_name || 'N/A'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {selectedGrievance?.user_email || 'N/A'}
                    </Typography>
                  </Paper>
                </Grid>

                {/* AC */}
                <Grid item xs={12} sm={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      height: 120,
                      borderRadius: 1.5,
                      bgcolor: '#e8f5e8',
                      boxSizing: 'border-box',
                      width: '100%',
                      overflow: 'hidden'
                    }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                      <PersonIcon color="success" fontSize="small" />
                      <Typography variant="subtitle2" fontWeight={600} noWrap>
                        Reviewed By (AC)
                      </Typography>
                    </Stack>
                    <Typography variant="body2" color="success.main" fontWeight={600} noWrap>
                      {selectedGrievance?.ac_modified_by?.name || 'AC Officer'}
                    </Typography>
                    {selectedGrievance?.ac_remarks && (
                      <Typography
                        variant="caption"
                        color="success.dark"
                        sx={{ 
                          mt: 0.5, 
                          display: 'block',
                          fontSize: '0.75rem',
                          lineHeight: 1.2,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        "{selectedGrievance.ac_remarks}"
                      </Typography>
                    )}
                  </Paper>
                </Grid>

                {/* JS */}
                <Grid item xs={12} sm={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      height: 120,
                      borderRadius: 1.5,
                      bgcolor: '#fff3e0',
                      boxSizing: 'border-box',
                      width: '100%',
                      overflow: 'hidden'
                    }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                      <PersonIcon color="warning" fontSize="small" />
                      <Typography variant="subtitle2" fontWeight={600} noWrap>
                        Reviewed By (JS)
                      </Typography>
                    </Stack>
                    <Typography variant="body2" color="warning.main" fontWeight={600} noWrap>
                      {selectedGrievance?.js_modified_by?.name || 'JS Officer'}
                    </Typography>
                    {selectedGrievance?.js_remarks && (
                      <Typography
                        variant="caption"
                        color="warning.dark"
                        sx={{ 
                          mt: 0.5, 
                          display: 'block',
                          fontSize: '0.75rem',
                          lineHeight: 1.2,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        "{selectedGrievance.js_remarks}"
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              </Grid>
            </Paper>

            {/* 3. Final Decision */}
            <Paper elevation={1} sx={{ p: 2.5, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                Final Decision <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Final Status</InputLabel>
                    <Select
                      name="resolved_by_sploca"
                      label="Final Status"
                      value={actionFormData.resolved_by_sploca}
                      onChange={handleActionFormChange}
                    >
                      <MenuItem value="True">Approved & Resolved</MenuItem>
                      <MenuItem value="False">Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12}>
                  <TextField
                    name="sploca_remarks"
                    label="SPLOCA Final Remarks *"
                    fullWidth
                    multiline
                    rows={4}
                    value={actionFormData.sploca_remarks}
                    onChange={handleActionFormChange}
                    placeholder="Enter final decision and remarks..."
                    required
                  />
                </Grid> */}
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                  <TextField
                    name="sploca_remarks"
                    label="SPLOCA Final Remarks *"
                    fullWidth
                    multiline
                    rows={4}
                    value={actionFormData.sploca_remarks}
                    onChange={handleActionFormChange}
                    placeholder="Enter final decision and remarks..."
                    required
                  />
                </Grid>
            </Paper>
          </DialogContent>

          <DialogActions sx={{ p: 3, pt: 1.5 }}>
            <Button
              onClick={() => setActionDialogOpen(false)}
              variant="outlined"
              disabled={submitLoading}
              sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSplocaActionSubmit}
              variant="contained"
              disabled={submitLoading || !actionFormData.sploca_remarks.trim()}
              sx={{
                textTransform: 'none',
                borderRadius: 2,
                px: 4,
                background: 'linear-gradient(135deg,#9c27b0 0%,#7b1fa2 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg,#8e24aa 0%,#6a1b9a 100%)',
                },
              }}
            >
              {submitLoading ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Finalizing...
                </>
              ) : (
                'Submit'
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <SnackBarComponent
          open={snackbarOpen}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Box>
    </Fade>
  );
};
